module.exports = __webpack_public_path__ + "media/assets/images/herb-d8caadfe450c4fc2a72c5e0d483c8a3a.svg";